















































































import { Component, Vue } from 'vue-property-decorator';
import { INarrative, IScenario } from '../models';
import { sortBy } from 'lodash';

@Component({
  components: {},
})
export default class AppBar extends Vue {
  private scenario: Partial<IScenario> | undefined = {};
  private activeNarrative: INarrative = {} as INarrative;
  private verticalDirection = false;

  private narrativeName(narrative: INarrative) {
    return `${narrative.name} (${narrative.included ? '✓' : 'x'})`;
  }

  private get sortedNarratives() {
    return this.scenario && this.scenario.narratives ? sortBy(this.scenario.narratives, 'name') : [];
  }

  private async narrativeSelected() {
    this.$store.actions.changeNarrative(this.activeNarrative);
  }

  private openDrawer() {
    this.$store.actions.toggleDrawer(true);
  }

  private toggleDirection() {
    this.$store.actions.setDirection(!this.verticalDirection);
  }

  async mounted(): Promise<void> {
    this.$store.states.map(s => {
      this.scenario = s.scenarios.current;
      this.activeNarrative = s.app.narrative || ({} as INarrative);
      this.verticalDirection = s.app.kanbanDirVert;
    });
  }
}
